import { styled } from '@clickcease/cc-client-components-lib'

export const HeatMapWrapper = styled('div', {
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  marginTop: '20px',
  overflow: 'hidden',
  flex: 2,
  paddingRight: '24px',
})

export const HeatMapTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '600',
  padding: '16px 12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const ChartContainer = styled('div', {
  padding: '20px',
  height: '360px',
  width: '100%',
})

export const TooltipStyle = {
  width: '16px',
  height: '16px',
}
